import React from 'react';

var Minus = function Minus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 13h14a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Minus.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Minus as icon };
export default iconHandler(Minus);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Minus.js
// module id = 612
// module chunks = 0